Number.prototype.map = function (in_min, in_max, out_min, out_max) {
    return Math.round(((this - in_min) * (out_max - out_min) / (in_max - in_min) + out_min) * 10) / 10
}

export const parallax = {
    bind(el, binding, vnode) {

        let self = el
        let bdy = document.querySelector('body')
        let bdy_w = bdy.clientWidth
        let bdy_h = bdy.clientHeight
        let pointer_x
        let pointer_y
        let sensitivity = 30
        let pos = {}
        let range = {}

        if (self) {
            self.style.position = 'relative'
            self.style.display = 'block'
            range = {
                in_min: -Math.abs((bdy_w / 2)),
                in_max: bdy_w / 2,
                out_min: -Math.abs(sensitivity * binding.value),
                out_max: sensitivity * binding.value
            }

            window.addEventListener('mousemove', (e) => {

                pos.x = ((bdy_w / 2) - e.pageX).map(range.in_min, range.in_max, range.out_min, range.out_max)
                pos.y = ((bdy_h / 2) - e.pageY).map(range.in_min, range.in_max, range.out_min, range.out_max)
                self.style.transform = `translate(${pos.x}px, ${pos.y}px)`
            })

            window.addEventListener('resize', () => {
                bdy_w = bdy.clientWidth
                bdy_h = bdy.clientHeight
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/directives/parallax.js